import React from 'react'
import { NavLink } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'

import styled from '@emotion/styled'
import { Typography } from '@mui/material'

import navRoutes from '../../navRouteArray'
import JasperLink from '../NavBar/Components/Jasper'
import { primaryColorOpacity, useIsMobile } from '@edge/spark/ui-mui'
import { useRoleNames, useCheckReportRoles, useIsGlobalAdmin, useIsAuctionAdmin } from '@edge/spark/io-roles'
import useAuctionId from '../Hooks/useAuctionId'
import showHideLink from './utils/showHideLink'
import SparkNextLink from './SparkNextLink'

const ListItem = styled.div`
    display: flex;
    padding: 10px;
    flex-direction: row;
    color: gray;
    align-items: center;
    justify-content: space-between;
    height: 20px;

    &.hoverIndex:hover {
        border-radius: 0px 50px 50px 0px;
        transition: 0.1s ease all;
        color: #009688;
        background: #f5f5f5;
    }
`
const StyledTypography = styled(Typography)`
    overflow: hidden;
    padding-left: 20px;
    textoverflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

interface Props {
    onClick?: () => void
}

const UserLinks: React.VFC<Props> = ({ onClick }: Props) => {
    const roles = useRoleNames()
    const isEdgeAdmin = useIsGlobalAdmin()
    const hasReportRole = useCheckReportRoles()
    const mobileView = useIsMobile()
    const auctionId = useAuctionId()
    const isAuctionAdmin = useIsAuctionAdmin()
    const ldFlags = useFlags()

    return (
        <div data-role={JSON.stringify({ hasReportRole, isEdgeAdmin, isAuctionAdmin, mobileView, roles })}>
            {navRoutes(auctionId).map((link) => {
                return showHideLink({
                    hasReportRole,
                    isEdgeAdmin,
                    isAuctionAdmin,
                    link,
                    mobileView,
                    roles,
                    ldFlags,
                }) ? (
                    <NavLink
                        style={{ textDecoration: 'none', outline: 'none' }}
                        data-test={link.testId}
                        onClick={onClick}
                        activeStyle={{
                            background: primaryColorOpacity,
                            borderRadius: '0px 50px 50px 0px',
                        }}
                        exact
                        to={link.path}
                        key={link.text}
                    >
                        <ListItem className="hoverIndex">
                            <link.Icon sx={{ paddingLeft: '10px' }} />
                            <StyledTypography variant="body2">{link.text}</StyledTypography>
                        </ListItem>
                    </NavLink>
                ) : null
            })}
            {(isEdgeAdmin || hasReportRole) && <JasperLink />}
            <SparkNextLink />
        </div>
    )
}

export default UserLinks
